import { useFilteredAvailableTimes } from "api/api-hooks/use-available-times";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useMemo } from "react";

/**
 * Hook to create a mapping from rule ID to section name.
 * This can be used to enhance activity data with proper section names.
 */
export const useSectionNameMapping = () => {
    const { date } = useBookingStateContext();
    const availableTimesData = useFilteredAvailableTimes(date);

    return useMemo(() => {
        if (!availableTimesData) return new Map<number, { id: number; name: string }>();

        const ruleToSectionMap = new Map<number, { id: number; name: string }>();
        availableTimesData.forEach((section) => {
            section.timeSets.forEach((timeSet) => {
                ruleToSectionMap.set(timeSet.id, { id: section.id, name: section.name });
            });
        });

        return ruleToSectionMap;
    }, [availableTimesData]);
};
